import { type PropsWithChildren } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';

import { useResponsive, Image } from '@sg/garnish';

import { ReceiptClaimHeroImage } from './assets';

export const ReceiptClaimContainer = (props: PropsWithChildren) => {
  const { currentBreakpoint } = useResponsive();

  if (currentBreakpoint.isXS) {
    return (
      <ScrollView
        style={styles.containerXS}
        contentContainerStyle={styles.grow}
        automaticallyAdjustKeyboardInsets
      >
        {props.children}
      </ScrollView>
    );
  }

  return (
    <View style={styles.containerSM}>
      <View style={styles.imageContainer}>
        <Image style={styles.image} source={ReceiptClaimHeroImage} />
      </View>

      <View style={styles.content}>{props.children}</View>
    </View>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flex: 1,
  },
  containerSM: {
    flex: 1,
    flexDirection: 'row',
  },
  imageContainer: {
    flex: 1,
  },
  image: {
    width: '100%',
    height: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  content: {
    flex: 1,
    alignSelf: 'center',
  },
});
